// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsIntellectualPropertyDetails } from 'components/_cardContents/resultsIntellectualProperty/resultsIntellectualProperty';

const Name = CONSTANTS.RESULTS.INTELLECTUAL_PROPERTY;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Innovation_Type__c',
        fieldName: 'Innovation_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Innovation_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsIntellectualPropertyDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Innovation_Type__c,
            Intellectual_Property_Id__c,
            Year__c,
        } = formData;

        // Data for sf
        return {
            Innovation_Type__c,
            Intellectual_Property_Id__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Text',
                name: 'Intellectual_Property_Id__c',
                object: object.config(
                    'Initiative_Result__c.Intellectual_Property_Id__c'
                ),
                maxLength: 200,
            },
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config(
                    'Initiative_Result__c.Year__c___Intellectual_Property'
                ),
                options: getYears(),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Intellectual_Property',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Innovation_Type__c,
        Intellectual_Property_Id__c,
        Year__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Innovation_Type__c', Innovation_Type__c);

    form.setValue('Intellectual_Property_Id__c', Intellectual_Property_Id__c);
    form.setValue('Year__c', Year__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
